
import React from 'react';
import { Button } from '@/components/ui/button';

interface ToggleViewProps {
  activeView: 'organizations' | 'users';
  onChange: (view: 'organizations' | 'users') => void;
}

const ToggleView: React.FC<ToggleViewProps> = ({ activeView, onChange }) => {
  return (
    <div className="flex bg-muted rounded-lg p-1 w-fit mb-6">
      <Button
        variant={activeView === 'organizations' ? 'default' : 'ghost'}
        className={`rounded-md ${activeView === 'organizations' ? '' : 'hover:bg-muted-foreground/10'}`}
        onClick={() => onChange('organizations')}
      >
        Organizations
      </Button>
      <Button
        variant={activeView === 'users' ? 'default' : 'ghost'}
        className={`rounded-md ${activeView === 'users' ? '' : 'hover:bg-muted-foreground/10'}`}
        onClick={() => onChange('users')}
      >
        Users
      </Button>
    </div>
  );
};

export default ToggleView;
